export const environment = {
  production: false,
  id: '4x',
  baseUrl: 'https://4x.superlikerslabs.com',
  photosPath: 'https://superlikers-staging.s3.amazonaws.com/uploads/upload-photo',
  // API-Sports (football). Se llama directo (sin proxy) con un cliente sin
  // interceptores; ver MatchesApi.
  apiSports: {
    baseUrl: 'https://v3.football.api-sports.io',
    key: '6d5532c6aebff87d0c5ef5f75d576858',
    league: 1,
    season: 2026
  }
}
